import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SportsComponent } from '@components/sports.component';
import { SlipDetailComponent } from '@components/slip-detail.component';
import { CasinoComponent } from '@components/casino.component';
import { EventDetailComponent } from '@components/eventdetail.component';
import { LiveEventDetailComponent } from '@components/liveeventdetail.component';
import { CashoutComponent } from '@components/cashout.component';
import { RouteGuardHelper } from '@helpers/route.guard.helper';
import { LiveComponent } from '@components/live.components';
import { DepositCreditCardComponent } from '@components/deposit-creditcard.component';
import { DepositCoinbaseComponent } from '@components/deposit-coinbase.component';
import { WithdrawCoinbaseComponent } from '@components/withdraw-coinbase.component';
import { OutrightsComponent } from '@components/outrights.component';
import { TicketDetailComponent } from '@components/ticketdetail.component';
import { PageComponent } from '@components/page.component';
import { RegisterSuccessComponent } from '@components/register-success.component';
import { AccountDownload } from '@components/account-download.component';
import { DepositPaydoxComponent } from '@components/deposit-paydox.component';
import { DepositPaydox2Component } from '@components/deposit-paydox2.component';
import { LiveCasinoComponent } from '@components/livecasino.component';
import { VirtualgameGRComponent } from '@components/virtualgameGR.component';
import { CasinoLobby } from '@components/casinolobby.component';
import { CasinoXPComponent } from '@components/casinoxp.component';
import { CasinoBSComponent } from '@components/casinobs.component';
import { CasinoBSLobbyComponent } from '@components/casinobslobby.component';
import { CasinoTrustLobbyComponent } from '@components/casinotrustlobby.component';
import { CashBackInfoComponent } from '@components/cashback-info.component';
import { CasinoRuLobbyComponent } from '@components/casinorulobby.component';
import { DepositIrgateComponent } from '@components/deposit-irgate.component';
import { DepositApcoComponent } from '@components/deposit-apco.component';
import { DepositApcoResultComponent } from '@components/deposit-apco-result.component';
import { DepositPayladoResultComponent } from '@components/deposit-paylado-result.component';
import { CasinoDSVirtualComponent } from '@components/casinodsvirtual.component';
import { DepositOnlineUeberComponent } from '@components/deposit-onlineueber.component';
import { DepositSofortComponent } from '@components/deposit-sofort.component';
import { DepositCoinPaymentsComponent } from '@components/deposit-coinpayments.component';
import { CasinoOgzSlotLobbyComponent } from '@components/casinoogzslotlobby.component';
import { DepositCashtoCodeComponent } from '@components/deposit-cashtocode.component';
import { DepositPaypalComponent } from '@components/deposit-paypal.component';
import { WithdrawMuchBetterComponent } from '@components/withdraw-muchbetter.component';
import { DepositSkrillComponent } from '@components/deposit-skrill.component';
import { DepositNetellerComponent } from '@components/deposit-neteller.component';
import { CasinoVivoLobbyComponent } from '@components/casinovivolobby.component';
import { CasinoGroupGALobbyComponent } from '@components/casinogroupgalobby.component';
import { WithdrawAuto } from '@components/withdraw-auto';
import { WithdrawAutoBanks } from '@components/withdraw-auto-banks.';
import { WithdrawAutoPaypal } from '@components/withdraw-auto-paypal';
import { WithdrawAutoMuchBetter } from '@components/withdraw-auto-muchbetter';
import { CurrentSlipCore } from '@components/current-slip.core';
import { AllSportsMenu } from '@components/all-sports-menu';
import { LongTermComponent } from '@components/longterm.component';
import { WithdrawResultComponent } from '@components/withdraw-result.component';
import { environment } from '@environments/environment';
import { DepositB3000Component } from '@sharedTemplates/deposit/b3000/deposit-b3000.component';
import { DepositWettarenaComponent } from '@sharedTemplates/deposit/wettarena/deposit-wettarena.component';
import { HelpB3000Component } from '@sharedTemplates/help/b3000/help-b3000.component';
import { HelpWettarenaComponent } from '@sharedTemplates/help/wettarena/help-wettarena.component';
import { HomeB3000Component } from '@sharedTemplates/home/b3000/home-b3000.component';
import { HomeWettarenaComponent } from '@sharedTemplates/home/wettarena/home-wettarena.component';
import { HomeB500Component } from '@sharedTemplates/home/b500/home-b500.component';
import { LoginB3000Component } from '@sharedTemplates/login/b3000/login-b3000.component';
import { LoginWettarenaComponent } from '@sharedTemplates/login/wetarena/login-wettarena.component';
import { LoginB500Component } from '@sharedTemplates/login/b500/login-b500.component';
import { Pay3000B3000Component } from '@sharedTemplates/pay3000/b3000/pay3000-b3000.component';
import { Pay3000WettarenaComponent } from '@sharedTemplates/pay3000/wettarena/pay3000-wettarena.component';
import { RegisterB3000Component } from '@sharedTemplates/register/b3000/register-b3000.component';
import { RegisterWettarenaComponent } from '@sharedTemplates/register/wettarena/register-wettarena.component';
import { WithdrawB3000Component } from '@sharedTemplates/withdraw/b3000/withdraw-b3000.component';
import { WithdrawWettarenaComponent } from '@sharedTemplates/withdraw/wettarena/withdraw-wettarena.component';
import { WithdrawPaypalB3000Component } from '@sharedTemplates/withdrawPaypal/b3000/withdraw-paypal-b3000.component';
import { WithdrawPaypalWettarenaComponent } from '@sharedTemplates/withdrawPaypal/wettarena/withdraw-paypal-wettarena.component';
import { CashoutNew } from '@components/cashout/cashout.new';
import { RegisterWettarenaPlComponent } from '@sharedTemplates/register/wettarena-pl/register-wettarena-pl.component';
import { HomeTerminalPeruComponent } from '@sharedTemplates/home/terminalPeru/home-terminalPeru.component';
import { LoginTerminalPeruComponent } from '@sharedTemplates/login/terminalPeru/login-terminalPeru.component';
import { LoginCangobetComponent } from '@sharedTemplates/login/cangobet/login-cangobet.component';
import { HomeCangobetComponent } from '@sharedTemplates/home/cangobet/home-cangobet.component';
import { CasinoLuckyStreakComponent } from './components/casinoluckystreak.component';
import { MailConfirm } from '@components/mail-confirm.component';
import { DocumentUpload } from '@components/document-upload.components';
import { RecoverPassword } from './components/recover-password.component';
import { CasinoGoldenRaceComponent } from './components/casinogoldenrace.component';
import { WithdrawApcoResultComponent } from './components/withdraw-apco-result.component';

let AppRoute: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '*', redirectTo: '/home', pathMatch: 'full' },
  { path: 'sports/:countryIDs[]/:TourementIDs[]', component: SportsComponent },
  { path: 'sports', component: SportsComponent },
  { path: 'search/:q', component: SportsComponent },
  { path: 'search', component: SportsComponent },
  { path: 'searchmatch/:q', component: SportsComponent },
  { path: 'slipdetail/:slipid', component: SlipDetailComponent, canActivate: [RouteGuardHelper] },
  { path: 'eventdetail/:eventid', component: EventDetailComponent },
  { path: 'live', component: LiveComponent },
  { path: 'liveeventdetail/:eventid', component: LiveEventDetailComponent },
  { path: 'livefixtureview', component: LiveComponent },
  { path: 'outrightsports/:tourid', component: OutrightsComponent },
  { path: 'ticketdetail/:ticketid/:subject', component: TicketDetailComponent, canActivate: [RouteGuardHelper] },
  { path: 'page/:pageName/:pageId', component: PageComponent },
  { path: 'registersuccess', component: RegisterSuccessComponent },
  { path: 'popular', component: SportsComponent },
  { path: 'highlights', component: SportsComponent },
  { path: 'lastminute', component: SportsComponent },
  { path: 'league', component: SportsComponent },
  { path: 'accountdownload', component: AccountDownload },
  { path: 'scanner', loadChildren: () => import('./components/scanner/scanner.module').then(m => m.ScannerModule) },
  { path: 'article/:pageName', component: PageComponent },
  { path: 'banner/:pageName', component: PageComponent },
  { path: 'fav', component: SportsComponent },
  { path: 'betslip', component: CurrentSlipCore },
  { path: 'mybets', component: environment.isNewCashout ? CashoutNew : CashoutComponent },
  { path: 'allsports', component: AllSportsMenu },
  { path: 'allsports/:id', component: AllSportsMenu },
  { path: 'outright/:tourid', component: LongTermComponent },
  { path: 'allevents', component: SportsComponent },
  { path: 'allevents/:MenuId/:TimeRangeId', component: SportsComponent },
  { path: 'mailconfirm', component: MailConfirm },
  { path: 'document', component: DocumentUpload },
  { path: 'recoverpassword', component: RecoverPassword },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '*', redirectTo: '/home', pathMatch: 'full' },
  { path: 'recoverpassword', component: RecoverPassword },
];
const paymentRoutes: Routes = [
  { path: 'withdrawcoinbase', component: WithdrawCoinbaseComponent },
  { path: 'withdrawresult/:statu', component: WithdrawResultComponent },
  { path: 'withdrawmuchbetter', component: WithdrawMuchBetterComponent, canActivate: [RouteGuardHelper] },
  { path: 'withdrawauto', component: WithdrawAuto },
  { path: 'withdrawautobanks', component: WithdrawAutoBanks },
  { path: 'withdrawautopaypal', component: WithdrawAutoPaypal },
  { path: 'withdrawautomuchbetter', component: WithdrawAutoMuchBetter },
  { path: 'depositneteller/:typeid/:depositId', component: DepositNetellerComponent, canActivate: [RouteGuardHelper] },
  { path: 'depositcoin', component: DepositCoinPaymentsComponent, canActivate: [RouteGuardHelper] },
  { path: 'depositcashtocode/:typeid/:depositId', component: DepositCashtoCodeComponent, canActivate: [RouteGuardHelper] },
  { path: 'depositpaypal/:statu/:depositId', component: DepositPaypalComponent, canActivate: [RouteGuardHelper] },
  { path: 'depositskrill/:typeid/:depositId', component: DepositSkrillComponent, canActivate: [RouteGuardHelper] },
  { path: 'depositcreditcard', component: DepositCreditCardComponent },
  { path: 'depositpaydox', component: DepositPaydoxComponent },
  { path: 'depositpaydox/:orderid/:ordercode/:goapihash', component: DepositPaydoxComponent },
  { path: 'depositpaydox2', component: DepositPaydox2Component },
  { path: 'depositpaydox2/:orderid/:ordercode/:goapihash', component: DepositPaydox2Component },
  { path: 'depositirgate', component: DepositIrgateComponent },
  { path: 'depositirgate/:order_id/:transaction_id/:amount', component: DepositIrgateComponent },
  { path: 'depositcoinbase', component: DepositCoinbaseComponent },
  { path: 'depositapco/:typeid/:depositId', component: DepositApcoComponent },
  { path: 'depositapcoresult/:statu', component: DepositApcoResultComponent },
  { path: 'withdrawapcoresult/:statu', component: WithdrawApcoResultComponent },

  { path: 'depositpayladoresult', component: DepositPayladoResultComponent },
  { path: 'depositou/:statu/:depositId', component: DepositOnlineUeberComponent },
  { path: 'depositsofort/:statu/:depositId', component: DepositSofortComponent },
];
const casinoRoutes: Routes = [
  { path: 'casino', component: CasinoComponent },
  { path: 'livecasino', component: LiveCasinoComponent },
  { path: 'virtualgamegr', component: VirtualgameGRComponent },
  { path: 'casinolobby', component: CasinoLobby },
  { path: 'casinoxp/:providerid', component: CasinoXPComponent },
  { path: 'casinobs/:gameid/:productid', component: CasinoBSComponent, canActivate: [RouteGuardHelper] },
  { path: 'casinobslobby', component: CasinoBSLobbyComponent },
  { path: 'casinotrslobby/:provider', component: CasinoTrustLobbyComponent, canActivate: [RouteGuardHelper] },
  { path: 'casinodsvirtual', component: CasinoDSVirtualComponent, canActivate: [RouteGuardHelper] },
  { path: 'casinorulobby/:provider', component: CasinoRuLobbyComponent, canActivate: [RouteGuardHelper] },
  { path: 'casinoslotlobby/:provider', component: CasinoOgzSlotLobbyComponent, canActivate: [RouteGuardHelper] },
  { path: 'casinovivolobby/:provider', component: CasinoVivoLobbyComponent, canActivate: [RouteGuardHelper] },
  { path: 'casinoluckystreak', component: CasinoLuckyStreakComponent },

  { path: 'casinogroupgalobby/:provider', component: CasinoGroupGALobbyComponent, canActivate: [RouteGuardHelper] },
];

const b3000AppRoutes: Routes = [
  { path: 'deposit', component: DepositB3000Component },
  { path: 'help', component: HelpB3000Component },
  { path: 'home', component: HomeB3000Component },
  { path: 'login', component: LoginB3000Component },
  { path: 'pay3000', component: Pay3000B3000Component },
  { path: 'register', component: RegisterB3000Component },
  { path: 'register/:branchcode', component: RegisterB3000Component },
  { path: 'withdraw', component: WithdrawB3000Component },
  { path: 'withdrawbanks', component: WithdrawB3000Component },
  { path: 'withdrawpaypal', component: WithdrawPaypalB3000Component, canActivate: [RouteGuardHelper] },
];
const wettarenaCommonAppRoutes: Routes = [
  { path: 'deposit', component: DepositWettarenaComponent },
  { path: 'help', component: HelpWettarenaComponent },
  { path: 'home', component: HomeWettarenaComponent },
  { path: 'login', component: LoginWettarenaComponent },
  { path: 'pay3000', component: Pay3000WettarenaComponent },
  { path: 'withdraw', component: WithdrawWettarenaComponent },
  { path: 'withdrawbanks', component: WithdrawWettarenaComponent },
  { path: 'withdrawpaypal', component: WithdrawPaypalWettarenaComponent, canActivate: [RouteGuardHelper] },
];
const wettarenaPlAppRoutes: Routes = [
  { path: 'deposit', component: DepositWettarenaComponent },
  { path: 'help', component: HelpWettarenaComponent },
  { path: 'home', component: HomeWettarenaComponent },
  { path: 'login', component: LoginWettarenaComponent },
  { path: 'pay3000', component: Pay3000WettarenaComponent },
  { path: 'register', component: RegisterWettarenaPlComponent },
  { path: 'register/:branchcode', component: RegisterWettarenaPlComponent },
  { path: 'withdraw', component: WithdrawWettarenaComponent },
  { path: 'withdrawbanks', component: WithdrawWettarenaComponent },
  { path: 'casinolobby', component: CasinoLobby },
  { path: 'withdrawpaypal', component: WithdrawPaypalWettarenaComponent, canActivate: [RouteGuardHelper] },
  { path: 'casinogoldenrace/:provider', component: CasinoGoldenRaceComponent, canActivate: [RouteGuardHelper] },
];

const wettarenaAppDERoutes: Routes = [
  { path: 'register', component: RegisterWettarenaComponent },
  { path: 'register/:branchcode', component: RegisterWettarenaComponent },
  { path: 'cashbackinfo', component: CashBackInfoComponent },
];

const b500AppRoutes: Routes = [
  { path: 'home', component: HomeB500Component },
  { path: 'login', component: LoginB500Component },
];

const betarenaAppRoutes: Routes = [{ path: 'home', component: HomeWettarenaComponent }];

const cangobetAppRoutes: Routes = [
  { path: 'home', component: HomeCangobetComponent },
  { path: 'login', component: LoginCangobetComponent },
];

const terminalPeruAppRoutes: Routes = [
  { path: 'home', component: HomeTerminalPeruComponent },
  { path: 'login', component: LoginTerminalPeruComponent },
];
if (environment.product === 'b3000') {
  AppRoute = [...AppRoute, ...b3000AppRoutes, ...paymentRoutes];
} else if (environment.product === 'b500') {
  AppRoute = [...AppRoute, ...b500AppRoutes, ...casinoRoutes];
} else if (environment.product === 'wettarena') {
  AppRoute = [...AppRoute, ...wettarenaCommonAppRoutes, ...wettarenaAppDERoutes, ...paymentRoutes];
} else if (environment.product === 'wettarena-pl') {
  AppRoute = [...AppRoute, ...wettarenaCommonAppRoutes, ...wettarenaPlAppRoutes, ...paymentRoutes];
} else if (environment.product === 'betarena') {
  AppRoute = [...AppRoute, ...betarenaAppRoutes, ...casinoRoutes];
} else if (environment.product === 'cangobet') {
  AppRoute = [...AppRoute, ...cangobetAppRoutes, ...casinoRoutes];
} else if (environment.product === 'terminalPeru') {
  AppRoute = [...AppRoute, ...terminalPeruAppRoutes, ...casinoRoutes];
}
//  canActivate: [RouteGuardHelper]
// todo Using default route loaded method. Must to try preload?
export const MobileRouting: ModuleWithProviders<any> = RouterModule.forRoot(AppRoute, {
  scrollPositionRestoration: 'enabled',
});
// export const MobileRouting: ModuleWithProviders = RouterModule.forRoot(MobileAppRoutes, { enableTracing: true });
